import React from 'react';

interface ToggleButtonProps {
  enabled: boolean;
  onToggle: () => void;
  label?: string;
  enabledText?: string;
  disabledText?: string;
  className?: string;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  enabled,
  onToggle,
  label = 'Auto-refresh',
  enabledText = 'ON',
  disabledText = 'OFF',
  className = '',
}) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {label && <span className="text-sm font-medium text-gray-700">{label}</span>}

      <button
        onClick={onToggle}
        className={`
          relative inline-flex h-7 w-16 items-center rounded-full
          transition-colors duration-300 ease-in-out
          ${enabled ? 'bg-primary' : 'bg-gray-300'}
        `}
        role="switch"
        aria-checked={enabled}
        aria-label={label}
      >
        {/* Toggle Circle */}
        <span
          className={`
            inline-block h-5 w-5 transform rounded-full
            bg-white shadow-lg transition-transform duration-300 ease-in-out
            ${enabled ? 'translate-x-10' : 'translate-x-1'}
          `}
        />

        {/* Text Labels */}
        <span
          className={`
            absolute text-xs font-semibold transition-opacity duration-200
            ${enabled ? 'left-2 opacity-100' : 'left-2 opacity-0'}
            text-white
          `}
        >
          {enabledText}
        </span>
        <span
          className={`
            absolute text-xs font-semibold transition-opacity duration-200
            ${enabled ? 'right-2 opacity-0' : 'right-2 opacity-100'}
            text-gray-600
          `}
        >
          {disabledText}
        </span>
      </button>
    </div>
  );
};
